import type { SettingsRepository } from "../../domain/settings/settings-repository";
import { LocalStorageSettingsRepository } from "./local-storage-settings-repository";
import { InMemorySettingsRepository } from "./memory-settings-repository";
import { isStorageAvailable } from "./progress-repository-factory";

/**
 * `SettingsRepository`の実装を環境に応じて選択するファクトリ（`progress-repository-factory.ts`と同じ方針）。
 * localStorageが使用可能ならそれを、不可能ならメモリ実装へフォールバックする。
 */
export function createSettingsRepository(
  storage: Storage = window.localStorage,
): SettingsRepository {
  return isStorageAvailable(storage)
    ? new LocalStorageSettingsRepository(storage)
    : new InMemorySettingsRepository();
}
